// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserAuthState, UserTypes } from '@interfaces/user.interfaces';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { AuthService } from '../../login/services/auth.service';
import { UserService } from '@services/user.service';

@Injectable({
    providedIn: 'root',
})
export class DealerGuard implements CanActivate {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly userService: UserService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.userService.userState$().pipe(
            filter((userState) => userState === UserAuthState.userLoaded),
            tap(() => {
                if (this.userService.user.userType === UserTypes.Customer) {
                    this.router.navigate(['/buyer']);
                }
            }),
            map(() => this.userService.user.userType === UserTypes.Dealer || this.userService.user.userType === UserTypes.Internal)
        );
    }
}
